module.exports = __webpack_public_path__ + "img/plan-a-off.1103a40c.png";